(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  function initEditorial(root) {
    if (!root || root.dataset.plEditorialReady === 'true') return;

    const track = root.querySelector('[data-pl-editorial-track]');
    const cards = Array.from(root.querySelectorAll('[data-pl-editorial-card]'));
    if (!track || cards.length < 2) {
      if (root) root.dataset.plEditorialReady = 'true';
      return;
    }

    root.dataset.plEditorialReady = 'true';

    const dots = Array.from(root.querySelectorAll('[data-pl-editorial-dot]'));
    const prev = root.querySelector('[data-pl-editorial-prev]');
    const next = root.querySelector('[data-pl-editorial-next]');
    const mobile = window.matchMedia(MOBILE_QUERY);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let timer = null;
    let scrollFrame = null;

    const isCarousel = () => root.dataset.mobileLayout === 'carousel';

    const targetLeft = (card) => {
      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      return track.scrollLeft + cardRect.left - trackRect.left;
    };

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === activeIndex;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    };

    const nearestCardIndex = () => {
      let nearest = 0;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const cardDistance = Math.abs(targetLeft(card) - track.scrollLeft);
        if (cardDistance < distance) {
          distance = cardDistance;
          nearest = index;
        }
      });
      return nearest;
    };

    const goTo = (index, smooth = true) => {
      if (!mobile.matches || !isCarousel()) return;
      const normalized = (index + cards.length) % cards.length;
      setActive(normalized);
      track.scrollTo({
        left: targetLeft(cards[normalized]),
        behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto'
      });
    };

    const stopAutoplay = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (
        !mobile.matches ||
        !isCarousel() ||
        root.dataset.autoplay !== 'true' ||
        reduceMotion.matches
      ) return;

      const seconds = Math.max(3, Number(root.dataset.autoplaySeconds) || 5);
      timer = window.setInterval(() => goTo(activeIndex + 1), seconds * 1000);
    };

    track.addEventListener('scroll', () => {
      if (!mobile.matches || !isCarousel()) return;
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => setActive(nearestCardIndex()));
    }, { passive: true });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
        startAutoplay();
      });
    });

    if (prev) {
      prev.addEventListener('click', () => {
        goTo(activeIndex - 1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        goTo(activeIndex + 1);
        startAutoplay();
      });
    }

    ['pointerdown', 'touchstart'].forEach((eventName) => {
      track.addEventListener(eventName, stopAutoplay, { passive: true });
    });

    ['pointerup', 'touchend'].forEach((eventName) => {
      track.addEventListener(eventName, startAutoplay, { passive: true });
    });

    const onViewportChange = () => {
      if (!mobile.matches) {
        stopAutoplay();
        track.scrollTo({ left: 0, behavior: 'auto' });
        setActive(0);
        return;
      }
      if (isCarousel()) {
        goTo(activeIndex, false);
        startAutoplay();
      }
    };

    if (mobile.addEventListener) mobile.addEventListener('change', onViewportChange);
    else mobile.addListener(onViewportChange);

    setActive(0);
    startAutoplay();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-pl-editorial]').forEach(initEditorial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();